<script lang="ts">
    import { scrollTo } from "svelte-scrollto"
    export let html = ""

    const r = /(?<=<h2>)(.*?)(?=<\/h2>)/g
    const matches = html?.match(r)
    console.log(matches)

    function findH2Element(text: string) {
        const h2s = document.querySelectorAll(".content h2")
        for (let i = 0; i < h2s.length; i++) {
            const h2 = h2s[i]
            if (text.includes(h2.textContent)) {
                return h2
            }
        }
    }
</script>

{#if matches?.length}
    <div class="content_table">
        <div class="headline"><slot /></div>
        <ul>
            {#each matches as s, idx}
                <li>
                    <a
                        href="#sprung{idx}"
                        on:click|preventDefault="{() => {
                            scrollTo({
                                element: findH2Element(s.replace(/<.*>/, '')),
                                offset: -150,
                            })
                        }}"
                        ><span class="icon"
                            ><img
                                src="/media/chevrons-right.svg"
                                alt=""
                            /></span
                        >{s.replace(/<.*>/, "")}</a
                    >
                </li>
            {/each}
        </ul>
    </div>
{/if}

<style lang="less">
    @import "../../css/base.less";

    .content_table {
        background: #fff;
        box-shadow: 0 0 40px 0 rgba(51, 51, 51, 0.2);
        padding: 25px;
        max-width: 580px;
        height: auto;
        width: 100%;
        margin-bottom: 15px;
        .headline {
            font-weight: 400;
            font-size: 1.5rem;
            margin-top: 0px;
            @media (max-width: 768px) {
                font-size: 1.2rem;
            }
            &:before {
                display: none;
            }
        }
        ul {
            list-style-type: none;
            margin: 15px 0px;
            padding: 0px;
            li {
                margin-bottom: 7px;
                a {
                    .flex();
                    align-items: flex-start;
                    .icon {
                        padding-top: 3px;
                        width: 20px;
                        height: 20px;
                        margin-right: 10px;
                        img {
                            width: 20px;
                            height: auto;
                        }
                    }
                    font-style: italic;
                }
            }
        }
    }
</style>
